import { Injectable, inject } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SettingService {
  private apollo = inject(Apollo);


  async isSettingEnabled(key: string): Promise<any> {
    return (await this.getSettingEnabled(key)) ?? false;
  }

  /**
   * Reads the setting as the anonymous role, null when no row comes back. A signed in user's query goes
   * over the websocket link, which drops the role header, so it runs as their own role and settings
   * readable by anonymous only (e.g. captcha) come back as null
   */
  async getSettingEnabled(key: string): Promise<boolean | null> {
    const resp = await firstValueFrom(
      this.apollo.query<any>({
        query: GET_SETTING_BY_KEY,
        variables: {
          key,
        },
        context: {
          headers: {
            'x-hasura-role': 'anonymous',
          },
        },
      }),
    );
    const setting = resp.data?.settings_by_pk;
    return setting ? setting.value?.enabled ?? false : null;
  }

  async isEnabled(key: string): Promise<any> {
    const resp = await firstValueFrom(
      this.apollo.query<any>({
        query: GET_SETTING_BY_KEY,
        variables: {
          key,
        }
      }),
    );
    return resp.data.settings_by_pk?.value?.enabled ?? false;
  }
}

const GET_SETTING_BY_KEY = gql`
  query getSettingByKey($key: String!) {
    settings_by_pk(key: $key) {
      key
      value
    }
  }
`;
